export const frameWalletSvg = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 307.5 306"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby="frameWallet"
  >
    <title id="frameWalletTitle">Frame Wallet Logo</title>
    <rect width="100%" height="100%" fill="#28272a" />
    <path
      fill="#00d2be"
      transform="translate(77, 76.5)"
      d="M145.1,75.6V17.6c0-5.1-4.2-9.3-9.3-9.3h-58.1c-.6,0-1.1-.2-1.6-.6l-7-7c-.4-.4-1-.7-1.6-.7H9.3C4.2,0,0,4.1,0,9.3h0v58c0,.6.2,1.1.6,1.6l7,7c.4.4.7,1,.7,1.6v58c0,5.1,4.2,9.3,9.3,9.3h58.2c.6,0,1.1.2,1.6.6l7,7c.4.4,1,.6,1.6.6h58.2c5.1,0,9.3-4.1,9.3-9.3h0v-58c0-.6-.2-1.1-.6-1.6l-7-7c-.5-.4-.8-.9-.8-1.5ZM105.6,106.6h-57.7c-.7,0-1.3-.6-1.3-1.3v-57.6c0-.7.6-1.3,1.3-1.3h57.7c.7,0,1.3.6,1.3,1.3v57.6c.1.7-.5,1.3-1.3,1.3Z"
    />
  </svg>
);
